import React from 'react';
import styled from 'styled-components';
import Outer from './Outer';
import Inner from './Inner';
import { useRouteMatch } from 'react-router-dom';
import Watermark from './Watermark';
import SupercardCornerBadgeSVGSC from './SupercardCornerBadgeSVG_SC-white-text';
import { Lottie } from '@crello/react-lottie';
import animationData from '../lottie/24983-jumping-feelings.json';

import {
  ToFromProps,
  CardBodyProps,
  BackgroundImageProps,
} from '../interfaces/cardInterfaces';

const To = styled.span<ToFromProps>`
  position: absolute;
  width: 94%;

  top: 11%;
  /* left: 5%; */
  margin: 0 0 0 0;
  z-index: 1;
  font-size: ${(props) => props.cardWidthInPx / 9}px;
  /* font-family: 'NB International Pro', sans-serif; */
  font-weight: 700;

  text-align: center;

  color: ${(props) => props.textColor};
  letter-spacing: ${(props) => (props.cardWidthInPx > 160 ? '0' : '0')};
  display: inline-block;
  height: ${(props) => props.cardWidthInPx / 1.85}px;
  overflow: hidden;
  line-height: 0.9;
`;
To.defaultProps = {
  'data-id': 'To',
};

const From = styled.span<ToFromProps>`
  position: absolute;
  width: 94%;
  top: 76%;
  /* left: 5%; */
  margin: 0 0 0 0;
  z-index: 1;
  font-size: ${(props) => props.cardWidthInPx / 9}px;
  text-align: center;
  color: ${(props) => props.textColor};
  letter-spacing: ${(props) => (props.cardWidthInPx > 160 ? 0 : 0)};

  /* font-family: 'NB International Pro', sans-serif; */
  font-weight: 700;
  display: inline-block;
  height: ${(props) => props.cardWidthInPx / 3.1}px;
  overflow: hidden;
  line-height: 1.05;
`;
From.defaultProps = {
  'data-id': 'From',
};

const BackgroundImage = styled.img<BackgroundImageProps>`
  display: block;
  position: absolute;
  width: ${(props) => props.cardWidthInPx}px;
  opacity: 1;
  border-radius: 8px;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;
BackgroundImage.defaultProps = {
  'data-id': 'BackgroundImage',
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
    className: 'bangin',
    id: 'some-id',
  },
};

const CardBody019: React.FC<CardBodyProps> = ({ to, from, cardWidthInPx }) => {
  let matchSelectedRoute = useRouteMatch('/selected');
  let matchEmailRoute = useRouteMatch('/email');

  return (
    <>
      <Outer cardWidthInPx={cardWidthInPx}>
        <Inner bcgColor={'linear-gradient(0deg, rgba(30,0,123,1) 0%, rgba(227,218,255,1) 100%)'} justifyContent={'center'}>
          {(matchSelectedRoute || matchEmailRoute) && (
            <Watermark
              width={51}
              top={70}
              left={47}
            />
          )}

          <To textColor={'black'} cardWidthInPx={cardWidthInPx}>
            Have a Bumpin' Birthday{' '}
            {to && to}
          </To>

          <div className="lottie-wrapper bangin" style={{ alignSelf: 'center', position:'relative', top:'4px' }}>
            <Lottie
              config={defaultOptions}
            />
          </div>

          <From textColor={'white'} cardWidthInPx={cardWidthInPx}>
            {from && from}
          </From>

          <SupercardCornerBadgeSVGSC widthinpx={cardWidthInPx} />
        </Inner>
      </Outer>
    </>
  );
};

export default CardBody019;
